import { defineComponent } from 'vue';
import { openBrandRegistrationEntry } from '@monolith/legacy/services/signup/brand-registration-entry';
import type { BrandFormType } from '@monolith/legacy/types/brand-form-type';

/**
 * Exposes the brand-registration entry CTA to the Blade-rendered App root so the
 * desktop "Apply as a brand" button (resources/views/includes/header/authBlock.blade.php)
 * can trigger it from a template `@click`. The mobile CTA (header-mobile.vue) calls the
 * same service directly; neither owns the tracking or the SEL-55 branch.
 */
export const brandRegistrationAnalyticsMixin = defineComponent({
  name: 'BrandRegistrationAnalyticsMixin',
  methods: {
    onApplyAsBrandClicked(): Promise<void> {
      // App exposes openAuthPopin via setup(); it is only reached on the legacy branch.
      const { openAuthPopin } = this as unknown as { openAuthPopin: (view: BrandFormType) => void };

      return openBrandRegistrationEntry(openAuthPopin);
    },
  },
});
